export const guides = [
  {
    id: "theorique",
    audience: "Pour vous, le professeur",
    title: "Guide Théorique du Professeur",
    description:
      "Tout le cadre pédagogique organisé pour savoir quoi enseigner, quand et comment l'expliquer, cours après cours.",
    tone: "dark",
    items: [
      "Planification annuelle par niveaux : débutant, intermédiaire et avancé",
      "La lecture musicale expliquée pas à pas, avec des scripts de cours",
      "Gammes, accords et intervalles dans leur ordre d'enseignement",
      "Corriger la posture, le doigté et les tensions dans les mains",
      "Critères d'évaluation et suivi de chaque élève",
    ],
  },
  {
    id: "pratique",
    audience: "Pour vos élèves",
    title: "Guide Pratique d'Exercices",
    description:
      "Des exercices prêts à imprimer et à distribuer, progressifs et pensés pour que l'élève travaille à la maison.",
    tone: "light",
    items: [
      "Plus de 150 exercices de technique, d'indépendance et de coordination",
      "Fiches de lecture en clé de sol et clé de fa",
      "Routines de pratique quotidienne de 10, 20 et 30 minutes",
      "Exercices de rythme et de pulsation par niveau de difficulté",
      "Feuilles de suivi pour que l'élève note ses progrès",
    ],
  },
];
